<div class="template1">
        <div class="text-center">
                <h3 class="content-message font-regular-weight">Coming Soon.. </h3>
        </div>
    </div>